import './YouTubeVideoModal.scss';

import { Modal } from '@trackman/web-shared-components';
import YouTubeVideoPlayer from 'components/YouTubeVideoPlayer/YouTubeVideoPlayer';
import { observer } from 'mobx-react-lite';

type Props = {
  isModalOn: boolean;
  setIsModalOn: (isModalOn: boolean) => void;
  modalData: { [key: string]: string };
};

export const YouTubeVideoModal = observer(({ isModalOn, setIsModalOn, modalData }: Props) => {
  return (
    <Modal onClose={() => setIsModalOn(false)} open={isModalOn} className='video-modal'>
      <div className='modal-body'>
        <YouTubeVideoPlayer youTubeId={modalData.videoId} title={modalData.videoLabel} />
      </div>
    </Modal>
  );
});

export default YouTubeVideoModal;
